import ClientCache from "@/utils/login/ClientCache.ts";

export default class EntityTypesUtils {
  static isDocument(entityType: string) {
    let entityTypesMetaData = ClientCache.entityTypesMetadata;
    if (entityTypesMetaData && entityTypesMetaData[entityType])
      return entityTypesMetaData[entityType].isDocument;
    return false;
  }

  static isMaster(entityType: string) {
    return !this.isDocument(entityType);
  }

  static hasAltCode(entityType: string) {
    let entityTypeMetaData = ClientCache.entityTypesMetadata[entityType];
    if (entityTypeMetaData)
      return entityTypeMetaData.withAltCode;
    return false;
  }
}
